import { ReactNode } from "react";
import classNames from "classnames";

interface CardProps {
  children?: ReactNode;
  header?: ReactNode;
  onClick?: () => void;
  id?: string;
}

export const Card = ({ children, header, onClick, id }: CardProps) => (
  <div
    id={id}
    className={classNames(
      "flex overflow-visible flex-col w-full h-full bg-white rounded-lg border shadow-md",
      {
        "cursor-pointer": !!onClick,
      }
    )}
    onClick={onClick}
  >
    {header && (
      <div className="p-2 md:px-4 text-2xl font-bold bg-neutral-400">
        {header}
      </div>
    )}
    {children}
  </div>
);
